import React from 'react'
import { ReactComponent as IconSatis } from '../../../../../../assets/icons/u_alert-check.svg'
import { OnePagerDoughnutChart } from '../../../components/OnePagerDoughnutChart'
import { useTranslation } from 'react-i18next';

const PmrIgr = ({ pmr }) => {
    const { t } = useTranslation();

    return (
        <div className="pmr">
            <div className='pmrIconContent'>
                <p>PMR</p>
                <IconSatis />
            </div>
            <p>{t('extended_report.PMR_description')}</p>
            <OnePagerDoughnutChart data={pmr} />
        </div>
    )
}

export default PmrIgr